import { render, staticRenderFns } from "./ProjectsQuestion.vue?vue&type=template&id=61654321&scoped=true"
import script from "./ProjectsQuestion.vue?vue&type=script&lang=js"
export * from "./ProjectsQuestion.vue?vue&type=script&lang=js"
import style0 from "./ProjectsQuestion.vue?vue&type=style&index=0&id=61654321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61654321",
  null
  
)

export default component.exports